<template>
	<div class="content">
        <div class="container-fluid">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">Monitor Mikrotik</h4>
                    <p class="card-category">Ini auto refresh setiap 1 menit</p>
                  </div>
                  <div class="col-md-6 text-right" v-show="data.adaWithdraw">
                    <div style="width: 40px; height: 40px;background-color:red;position:absolute;right:0;margin-right:30px"></div>
                  </div>
                </div>
              </div>
              <div class="card-body" >
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th width="40px">No.</th>
                      <th>Nama</th>
                      <th>Secret</th>
                      <th>Active</th>
                      <th>Non Active</th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in theGet.data.Listx" >
                        <td>{{ index+1 }}</td>
                        <td><h3 class="mb-0">{{ u.nama }}</h3>{{ u.ip }}</br>
                          <span v-if="u.via == 'ip'">IP Public</span>
                          <span v-else>Tunnel</span>
                        </td>

                        <td class="text-info"><router-link :to="{ name: 'detail-secret', params: { page: 'secret', ip:u.ip, username: u.username, password: u.password, via: u.via }}"><h2>{{u.secret}}</h2></router-link></td>
                        <td class="text-success"><router-link :to="{ name: 'detail-secret', params: { page: 'active', ip:u.ip, username: u.username, password: u.password, via: u.via }}"><h2>{{u.active}}</h2></router-link></td>
                        <td class="text-danger"><router-link :to="{ name: 'detail-secret', params: { page: 'nonactive', ip:u.ip, username: u.username, password: u.password, via: u.via }}"><h2>{{u.nonactive}}</h2></router-link></td>

                      </tr>
                      
                      <tr>
                        <td colspan="8" class="text-success">
                          <div class="alert alert-info" role="alert">
                            Sedang mengambil data...
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="8" class="text-success">FYI : Mikrotik anda akan muncul satu persatu ketika total secret selesai di ambil dari Mikrotik anda.</td>
                      </tr>

                      <tr v-if="theGet.data.List == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
    	</div>
    </div>

</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 
import axios from 'axios'
import VueAxios from 'vue-axios'

export default {
  name: 'Beranda',
  components: { 
    'Loading': Loading
  }, 
  setup() {
    const data = reactive({
      modalDetail: false,
      modalHapus: false,
      adaWithdraw: false,

      /* modal edit tarif */
    })

    const theGet = {
      data: reactive({
        ListBackup: [],
        List: [],
        Listx: [],

        totalList: 0,
        totalDone: 0
      }),
      datae() {
        //console.log(sessionStorage.getItem('admin'));
			  // for filter

        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken')
        }
			
        var apiUrl = inter.MiktorikList();
        myGlobal.call(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          if (x.status == true) {
              this.data.List = x.data;
              this.data.ListBackup = x.data;
              this.data.totalList = x.data.length;
              this.data.totalDone = 0;
              console.log(this.data.totalList);
              console.log("done " + this.data.totalDone);
              
              this.data.List = this.data.List.map(async item => {
                item = await mikrotik.getBlogCount(item.via,item.ip,item.username,item.password,item.nama); // item.identifier
                
                //console.log(item.ip);

                this.data.Listx.push(item);

                this.data.totalDone = this.data.totalDone + 1;
                if (this.data.totalDone >= this.data.totalList) {
                    setTimeout(() => { 
                        this.data.totalDone = 0;
                        this.data.Listx = null;
                        this.data.Listx = [];
                        this.dataeRefresh();
                        //////////////////////
                        //this.withdraw();
                    }, 60000);
                }
                
                //return item;
              })        

          } else {
              
          }
        })
      },
      dataeRefresh() {
        console.log("REFRESH BWANG");
        this.data.List = this.data.ListBackup;

        this.data.List = this.data.List.map(async item => {
            item = await mikrotik.getBlogCount(item.via,item.ip,item.username,item.password,item.nama); // item.identifier
            
            //console.log(item.ip);

            this.data.Listx.push(item);

            this.data.totalDone = this.data.totalDone + 1;
            if (this.data.totalDone >= this.data.totalList) {
                setTimeout(() => { 
                    this.data.totalDone = 0;
                    this.data.Listx = null;
                    this.data.Listx = [];
                    this.dataeRefresh();
                    //////////////////////
                    //this.withdraw();
                }, 60000);
            }
            //return item;
        })    
      },
      withdraw() {
        console.log("Panggil w");

        var header = {'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': "application/json"
        };  
        axios({
          method: "POST",
          url: "https://blonjo.web.id/beat/API/WIFI/admin/content/beranda/jumlah-withdraw",
          headers: header
        }).then((response) => {
            console.log("Hasil w"),
            // console.log(JSON.stringify(response.data)),
            this.whasil(response.data.data.withdraw)
        })
        .catch(error => {
          var error = error.response.status;
          //this.error(error);
        }); 
      },
      whasil(jumlah) {
        var jml = parseInt(jumlah);

        if (jml > 0) {
          data.adaWithdraw = true
        }
      }
    }

    const mikrotik = {
      data: reactive({
        loading: true,
        secret: 0,
        active: 0,
        nonactive: 0,
        idHapus: '',
        ip: '',
        username: '',
        password: '',
        via: '',
      }),
      detailx(data) {
        console.log(JSON.stringify(data));
      },  
      detail(via,ip,username,password) {
        console.log("Get Info Mikrotik");
			  // for filter

        this.data.ip = ip;
        this.data.via = via;
        this.data.username = username;
        this.data.password = password;

        var datax = {
            ip: ip,
            username:username,
            password:password,
            via:via
        }
			
			  var apiUrl = "beranda.php";
        myGlobal.callMikrotik(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          if (x.status == true) {
            var datae = x.data;
            this.data.loading = false;
            this.data.secret = datae.secret;
            this.data.active = datae.active;
            this.data.nonactive = parseInt(datae.secret) - parseInt(datae.active);
          } else {

          }
        })
      },
      hapus() {
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            id: this.data.idHapus
        }
			
			  var apiUrl = inter.MiktorikHapus();
        myGlobal.call(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          if (x.status == true) {
            theGet.datae();
          } else {
              //alert(x.pesan);
          }
        })
      },
      secret() {

      },
      getBlogCount(via,ip,username,password,name) {
        var datax = {
          ip: ip,
          username:username,
          password:password,
          via:via
        }
			
        var apiUrl = "beranda.php";
        return myGlobal.callMikrotik(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));

          let data;

          if (x.status == true) {
            var datae = x.data;
            /*
            this.data.loading = false;
            this.data.secret = datae.secret;
            this.data.active = datae.active;
            this.data.nonactive = parseInt(datae.secret) - parseInt(datae.active);
            */

            data = {
              via: via,
              ip: ip,
              username: username,
              password: password,
              nama: name,
              secret: datae.secret,
              active: datae.active,
              nonactive: parseInt(datae.secret) - parseInt(datae.active),
            };
            
          } else {
            data = {
              via: via,
              ip: ip,
              username: username,
              password: password,
              nama: name,
              secret: 0,
              active: 0,
              nonactive: 0
            };
          }

          return data;

        })
        
      },
      
      getBlogUser(via,ip,username,password,name) {
        var datax = {
          ip: ip,
          username:username,
          password:password,
          via:via
        }
			
        var apiUrl = "list-pelanggan-nonaktif.php";
        return myGlobal.callMikrotik(datax,apiUrl).then(x => {
          console.log(JSON.stringify(x));

          let data;
          
          if (x.status == true) {
            var datae = x.data;
            data = {
              via: via,
              ip: ip,
              username: username,
              password: password,
              nama: name,
              secret: datae.secret,
              active: datae.active,
              nonactive: parseInt(datae.secret) - parseInt(datae.active),
            };
            
          } else {
            data = {
              via: via,
              ip: ip,
              username: username,
              password: password,
              nama: name,
              secret: 0,
              active: 0,
              nonactive: 0
            };
          }

          return data;

        })
        
      }
    } // 
    return {
      data, 
      theGet,
      mikrotik
    }
  },
  mounted () {
    document.title = "List Mikrotik";

    // this.theGet.withdraw();

    this.theGet.datae();

    
  }
}
</script>
<style scoped>  
.fix {
	position: fixed;
	right: 0;
	top: 0;
	bottom: 0;
	left: 0;
}
.flex {
	display: flex;
	height: 100%;
}
.left-fix {
	width: 40%;
	background: linear-gradient(60deg, #66bb6a, #43a047);
    align-items: center;
	display: flex;
	padding-left: 30px;
	padding-right: 30px;
}
.right-fix {
	width: 60%;
	display: flex;
    align-items: center;
}
.icon {
	width: 170px;
}
.margin0 {
	margin: 0 auto;
	width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor.vue